import React from 'react';

import { useEmailMessageTimelineLogItemsQuery } from '@dashboard/generated/wp/platform';
import { getTimelineLogItemLabel } from '@dashboard/models/TimelineLogItem';
import { Skeleton, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react-formatters';

type Props = {
  templateEventId: string;
};
export default function LastMessageEventSentence({ templateEventId }: Props) {
  const { data } = useEmailMessageTimelineLogItemsQuery({ variables: { id: templateEventId } });
  const nodes = data?.TimelineLogItems.nodes;

  if (!nodes) {
    return <Skeleton />;
  }
  if (nodes.length === 0) {
    return <>None</>;
  }
  const event = nodes[0];
  return (
    <Typography variant="body2" color="text.secondary">
      <strong>{getTimelineLogItemLabel(event)}</strong>
      {' on '}
      <DateFormatter value={event.createdAt} template="LL h:mm a" />
    </Typography>
  );
}
